<template>
	<div class="container">
		<div class="row">
			<div class="col-12 mt-4">
				<h1>Wähle ein Quiz</h1>
				<p>Durch Fragen besser in Mathe.</p>
			</div>

			<div class="col-12" v-if="Object.keys(quizzes).length">
				<div class="row">
					<div v-for="(quiz, key) in quizzes" :key="quiz.key" class="col-12 col-sm-6 col-md-4 col-lg-4 mt-3">
						<b-card :title="quiz.name" :sub-title="quiz.questions.length + ' Fragen'">
							<!-- <pre>{{quiz}}</pre> -->
							<!-- <router-link :to="{name: 'QuizByName', params: {name: toUrl(quiz.name)}}">{{quiz.name}}</router-link> -->
							<!-- <router-link :to="{name: 'QuizByName', params: {name: toUrl(quiz.name)}}">Quiz starten</router-link> -->
							<div class="text-right">
							<b-button :to="{name: 'QuizByName', params: {name: toUrl(quiz.name)}}">Quiz starten</b-button>
							</div>
						</b-card>
					</div>
				</div>
			</div>

			<div v-else class="col-12 mt-5">
				<i class ="fa fa-spin fa-spinner fa-fw text-muted"></i> Quizzes werden geladen.
			</div>

		</div>
	</div>
</template>

<script>
	// import autosize from "autosize";

	import {toUrl} from '../helper.js'

	export default {
		data(){
			return {
				toUrl: toUrl
			}
		},
		metaInfo(){
			return {
				meta: [
				{name: 'description', content: this.quizCount + ' Online Tests mit denen du dein Wissen testen kannst.'}
				]
			}
		},

		beforeCreate(){
			this.$store.dispatch('loadPublicQuizzes')
		},

		computed: {
			quizCount(){
				return this.quizzes ? this.quizzes.length : 0
			},
			quizzes(){
				// console.log('Quizzes: ', this.$store.state.publicQuizzes.length)

				return this.$store.state.publicQuizzes
			}
		}

	}
</script>

<style>
	
</style>


// WEBPACK FOOTER //
// Home.vue?5d672fde